module.exports = __webpack_public_path__ + "static/img/9.f72ec5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/9.png
// module id = qTvi
// module chunks = 7